import { render, staticRenderFns } from "./reset-password-page.vue?vue&type=template&id=321319d3"
import script from "./reset-password-page.vue?vue&type=script&lang=js"
export * from "./reset-password-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports